/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type representing a participant role.
 */
export enum ParticipantRole {
    USER = 'user',
    CONTACT = 'contact',
    SYSTEM = 'system',
}
